export enum PaymentType {
  SUBSCRIPTION = 'subscription',
  ONE_TIME_PAYMENT = 'oneTimePayment'
}
